var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:expressTrackingList:export",
                  expression: "'btn:expressTrackingList:export'",
                  arg: "remove",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.allExportOrder },
            },
            [_vm._v(" " + _vm._s(_vm.$t("newOrder.export")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
            "row-key": "id",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "80",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.center,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "stateName"
                          ? _c(
                              "div",
                              [
                                _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("customerManagements.enable"))
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "--"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.Note"),
              width: "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.toEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.edit")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.Note"),
            visible: _vm.noteVisible,
            width: "30%",
            "before-close": _vm.noteClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.noteVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "remarkFormRef",
              attrs: { model: _vm.remarkForm },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "remark",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("collectionCenter.pleaseInput"),
                        trigger: ["blur", "change"],
                      },
                      {
                        min: 0,
                        max: 300,
                        message: _vm.$t("collectionCenter.outRange"),
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("collectionCenter.pleaseInput"),
                      clearable: "",
                      maxlength: "300",
                      "show-word-limit": "",
                    },
                    on: { blur: _vm.filRemark },
                    model: {
                      value: _vm.remarkForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.remarkForm, "remark", $$v)
                      },
                      expression: "remarkForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.noteClose } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.noteSubmit } },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }